import { Icon, Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import ContactCell from '../components/ContactCell';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import AgentBranchCell from '../components/AgentBranchCell';
import StatusCell from '../components/StatusCell';

export default function ReservationsCreatedTableRow({ row }) {
  const {
    status,
    agents,
    reservation_value,
    property_type,
    id,
    branches,
    created_at,
    contact,
    operation_value,
    expiration_date,
    operation_type,
    property,
  } = row;

  const arbitraryAgent = agents[0];
  const arbitraryBranch = branches[0];

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={property?.id}
          thumbnail={property?.thumbnail}
          address={property?.address}
          location={property?.location}
          modal="addedProperties"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {!operation_type && !property_type && (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
        {operation_type && (
          <Text variant="body.fontSize13">{operation_type}</Text>
        )}
        {property_type && (
          <Text variant="body.fontSize13">{property_type.name}</Text>
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {!reservation_value && !operation_value && (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
        {reservation_value && (
          <Text variant="body.fontSize13">{`${reservation_value.currency} ${reservation_value.amount}`}</Text>
        )}
        {operation_value && (
          <Text variant="body.fontSize13">{`${operation_value.currency} ${operation_value.amount}`}</Text>
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          highlighted={false}
          id={contact?.id}
          image={contact?.thumbnail}
          name={contact?.name}
          email={contact?.email}
          cellphone={contact?.cellphone}
          leadStatus={contact?.lead_status}
          agent={arbitraryAgent}
          relativeSelector="#reservations-created-modal"
          modal="reservationsCreated"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={arbitraryAgent?.id}
          agentName={arbitraryAgent?.name}
          branchName={arbitraryBranch?.name}
          image={arbitraryAgent?.profile_picture}
          relativeSelector="#reservations-created-modal"
          modal="reservationsCreated"
          withBranch
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <StatusCell id={status.id} text={status.text} />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{created_at}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {expiration_date ? (
          <Text variant="body.fontSize13">{expiration_date}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
        )}
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
